module.exports = __webpack_public_path__ + "img/reactions-sad.4c6e4a5e.svg";